export default __webpack_public_path__ + "static/media/sounds/clpl_scroll_down.mp3";